export interface ITimeSettings {
    timeSlice: "d" | "w" | "m" | "y";
    slices?: number;
    inicio?: number;
}

export function groupBy<T>(
    array: Array<T>,
    keyRule: (element: T) => string | undefined,
    includeUndefined?: boolean
) {
    const map = new Map<string | undefined, Array<T>>();
    array.forEach((element) => {
        const key = keyRule(element);
        if (key !== undefined || includeUndefined) {
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [element]);
            } else {
                collection.push(element);
            }
        }
    });
    return map as Map<string, Array<T>>;
}
export function count(array: Array<Array<any>>) {
    return array.map((element) => element.length);
}

export function sliceByTime<T>(
    array: Array<T>,
    dateRule: (e: T) => string,
    settings: ITimeSettings
) {
    const { timeSlice, slices, inicio } = settings;

    const downLimit = inicioDoPeriodo(
        inicio || new Date(dateRule(array[0])).getTime(),
        timeSlice
    );
    const upLimit = new Date(dateRule(array[array.length - 1])).getTime();

    let periodo = 24 * 60 * 60 * 1000; /*milisegundos de uma hora */
    periodo *=
        timeSlice === "w"
            ? 7
            : timeSlice === "m"
            ? 30
            : timeSlice === "y"
            ? 365
            : 1;

    const dados: Array<Array<T>> = [];
    const datas: Array<{ inicio: number; fim: number }> = [];
    const sliced = {
        datas,
        dados,
    };

    // preenche vetor de datas e inicializa vetor de dados
    for (
        let index = 0;
        index < (slices || (upLimit - downLimit) / periodo);
        index++
    ) {
        dados[index] = [];
        datas[index] = {
            inicio: downLimit + periodo * index,
            fim: downLimit + periodo * (index + 1),
        };
    }

    //preenche vetor de dados
    array.forEach((element) => {
        const index = Math.floor(
            (new Date(dateRule(element)).getTime() - downLimit) / periodo
        );
        if (dados[index]) dados[index].push(element);
    });

    return sliced;
}

function inicioDoPeriodo(timeStamp: number, timeSlice: "d" | "w" | "m" | "y") {
    const dateAtMidnight = new Date(new Date(timeStamp).toDateString());
    if (timeSlice === "w") {
        dateAtMidnight.setDate(
            dateAtMidnight.getDate() - dateAtMidnight.getDay()
        );
    } else if (timeSlice !== "d") {
        dateAtMidnight.setDate(1);
        if (timeSlice === "y") dateAtMidnight.setMonth(0);
    }
    return dateAtMidnight.getTime();
}

export function objectEquality(objetoA: any, objetoB: any) {
    if (objetoA === objetoB) return true;

    if (!objetoA || !objetoB) return false;

    //Busca as chaves do objetoA e objetoB
    const aChaves = Object.keys(objetoA);
    const bChaves = Object.keys(objetoB);

    //Compara os tamanhos, se forem diferentes retorna falso pois
    //o numero de propriedades é diferente, logo os objetos são diferentes
    if (aChaves.length !== bChaves.length) {
        return false;
    }

    //Verifico se existe algum elemento com valor diferente nos objetos.
    const saoDiferentes = aChaves.some((chave) => {
        return objetoA[chave] !== objetoB[chave];
    });

    return !saoDiferentes;
}

export function arrayEquality(arrayA: Array<any>, arrayB: Array<any>) {
    if (arrayA === arrayB) return true;
    if (arrayA.length !== arrayB.length) return false;

    for (let i = 0; i < arrayA.length; i++) {
        const elementA = arrayA[i];
        const elementB = arrayB[i];

        if (
            elementA !== elementB && // comparar valores primitivos
            !(
                typeof elementA === "object" &&
                typeof elementB === "object" &&
                objectEquality(elementA, elementB)
            ) // comparar objetos
        )
            return false;
    }

    return true;
}

export function getBase64URL(file: File) {
    return new Promise((resolve: (b64: string) => void, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
}

export function downloadLink(
    href: string,
    options?: {
        target?: string;
    }
) {
    let aElement = document.createElement("a");
    aElement.href = href;
    if (options?.target) aElement.target = options.target;

    aElement.click();
}
